import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

var gap = document.getElementById("gap").clientWidth;
var gap2x = document.getElementById("gap-2x").clientWidth;
var mVert = document.getElementById("m-vert").clientWidth;
var mVertSlim = document.getElementById("m-vert-slim").clientWidth;
var widthMargin = document.getElementById("width-margin").clientWidth;
var articleWidth = document.getElementById("article-width").clientWidth;

window.addEventListener('load',function() {
    
    var hero = null;

    if(hero = document.querySelector('.wp-block-zd-hero')) {
        const swiperElement = hero.querySelector('.swiper-container');
        if (swiperElement) {
            swiperElement.querySelectorAll('.swiper-slide').forEach((slide) => {
                const bgImage = slide.getAttribute('data-bg-image');
                if (bgImage) {
                    slide.style.backgroundImage = `url(${bgImage})`;
                }
                const video = slide.getAttribute('data-bg-video');
                if (video) {
                    const videoElement = document.createElement('video');
                    videoElement.setAttribute('src', video);
                    videoElement.setAttribute('playsinline', '');
                    videoElement.setAttribute('muted', '');
                    videoElement.setAttribute('loop', '');
                    videoElement.addEventListener('loadedmetadata', () => {
                        const duration = Math.floor(videoElement.duration * 1000);
                        slide.setAttribute('data-swiper-autoplay', duration);
                        slide.appendChild(videoElement);
                        videoElement.play();
                    });
                }
            });
            new Swiper(swiperElement, {
                modules: [Autoplay, Pagination, EffectFade],
                lazy: true,
                effect: 'fade',
                speed: 1000,
                autoplay: {
                    delay: 2000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                on: {
                    init: function() {
                    },
                    transitionStart: function() {
                        const activeSlide = this.slides[this.activeIndex];
                        window.setTimeout(() => {
                            const video = activeSlide.querySelector('video');
                            if (video) {
                                video.play();
                            }
                        }, 500);
                    },
                    transitionEnd: function() {
                    }
                },
            });
        }
    }

    var galerie = null;

    if(galerie = document.querySelector('.wp-block-zd-galerie')) {
        const swiperElement = galerie.querySelector('.swiper-container');
        if (swiperElement) {
            new Swiper(swiperElement, {
                modules: [Autoplay],
                lazy: false,
                spaceBetween: 20,
                loop: true,
                speed: 5000,
                autoplay: {
                    delay: 0
                },
                on: {
                    slideChange: function() {
                        const idx = this.realIndex;
                        const count = this.slides.length - 2;
                        document.querySelector('.claim.show').classList.remove('show');
                        document.querySelector('.claim:nth-child(' + ((idx % 3) + 1) + ')').classList.add('show');
                    }
                }
            });
        }
    }

    const triggerElement = document.getElementById("trigger");
    if (triggerElement) {
        triggerElement.addEventListener("click", function (el) {
            var el = document.getElementById("trigger");
            if (el.classList.contains("open")) {
                el.classList.remove("open");
                document.querySelector("body").classList.remove("scroll-lock");
                document.getElementById("mobile_menu").classList.remove("open");
            } else {
                el.classList.add("open");
                document.querySelector("body").classList.add("scroll-lock");
                document.getElementById("mobile_menu").classList.add("open");
            }
        });
    }

    const animateElements = document.querySelectorAll('.animate');
    const viewportTopThird = window.innerHeight / 3;
    const viewportBottomThird = window.innerHeight * 0.75;
    var resetDelayTimeout;
    var delay = 0;
    var lastScrollY = window.scrollY;
    function checkAnimateElements() {

        const header = document.querySelector('header');
        if (header) {
            if (window.scrollY > lastScrollY) {
                header.classList.add('scrolled', 'down');
            } else {
                header.classList.remove('down');
            }
            if (window.scrollY > 0) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
            lastScrollY = window.scrollY;
        }

        animateElements.forEach(element => {
            const rect = element.getBoundingClientRect();
            const elementTop = rect.top;
            const elementBottom = rect.bottom;
            if ((elementTop <= viewportBottomThird && elementTop >= 0) || 
                (elementBottom <= viewportTopThird && elementBottom >= 0)) {
                if(!element.classList.contains('do')) {
                    element.style.animationDelay = delay + 'ms';
                    element.classList.add('do');
                    delay += 100;
                    console.log('Animating element with delay: ' + delay + 'ms');
                    clearTimeout(resetDelayTimeout);
                    resetDelayTimeout = setTimeout(() => {
                        delay = 0;
                    }, 1000);
                }
            }
        });
    }

    checkAnimateElements();
    window.addEventListener('scroll', checkAnimateElements);

    document.querySelectorAll('.wp-block-gb-accordion').forEach(function(el) {
        el.addEventListener('click', function() {
            var parentEl = el.parentElement;
            var dataClass = el.getAttribute('data-class');
            if(dataClass && document.querySelector('.'+dataClass)) {                
                document.querySelector('.'+dataClass).classList.add('show');
            }
            var h = el.querySelector('.inner>div').clientHeight;
            document.querySelectorAll('.wp-block-gb-accordion').forEach(function(elOther) {
                if(elOther != el) {
                    elOther.querySelector('.inner').style.height = '0px';
                    elOther.classList.remove('open');
                }
            });
            if (el.classList.contains('open')) {
                el.querySelector('.inner').style.height = '0px';
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
                window.setTimeout(
                    function() {
                        var rect = el.getBoundingClientRect();
                            if(rect.top < 144) {
                                el.scrollIntoView();
                            }
                        }, 400
                    )
                }
            });
            if(el.classList.contains('initialOpen')) {
                el.querySelector('.inner').style.height = el.querySelector('.inner>div').clientHeight + 'px';
                var dataClass = el.getAttribute('data-class');
                document.querySelector('.'+dataClass).classList.toggle('show');
            }
    });

})